import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";
import { authenticateWithPasskey } from "../../services/passkeyService";

export const Login = createAsyncThunk("login", async (value) => {
  try {
    let info = await Api.post("login", value);
    if (info.data.status_code === 200) {
      localStorage.setItem("authorization", info.data.data.token);
      window.location.href = info.data.data.permission[0].url;
    } else {
      toast.error(info.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
});

export const LoginWithPasskey = createAsyncThunk("loginWithPasskey", async (email) => {
  try {
    const result = await authenticateWithPasskey(email);
    if (result.status_code === 200) {
      localStorage.setItem("authorization", result.data.token);
      window.location.href = result.data.permission[0].url;
      return result;
    } else {
      toast.error(result.message);
      throw new Error(result.message);
    }
  } catch (error) {
    toast.error(error.message || 'Passkey authentication failed');
    throw error;
  }
});

export const createAdmin = createAsyncThunk("create-admin", async (value) => {
  try {
    let info = await Api.post("create-admin", value);
    if (info.data.status_code === 200) {
    } else {
      toast.error(info.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
});
//

export const deleteAdmin = createAsyncThunk("delete-admin", async (value) => {
  try {
    let info = await Api.delete(`delete-admin/${value}`);
    if (info.data.status_code === 200) {
      return info.data;
    } else {
      toast.error(info.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
});

export const updateAdmin = createAsyncThunk("update-admin", async (value) => {
  try {
    let info = await Api.post("update-admin", value);
    if (info.data.status_code === 200) {
    } else {
      toast.error(info.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
});

export const getSubAdminInfo = createAsyncThunk(
  "get-sub-admin-info",
  async (id) => {
    try {
      let info = await Api.get(`get-sub-admin-info/${id}`);
      if (info.data.status_code === 200) {
        return info.data;
      } else {
        toast.error(info.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const dashboard = createAsyncThunk("udashboard", async () => {
  try {
    let info = await Api.get("/dashboard-stats");
    if (info.data.status_code === 200) {
      return info.data;
    } else {
      toast.error(info.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
});

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async (value) => {
    try {
      let info = await Api.post("resetPassword", value);
      if (info.data.status_code === 200) {
        return info.data.data;
      } else {
        toast.error(info.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const forgetpassword = createAsyncThunk(
  "forgetpassword",
  async (value) => {
    try {
      let info = await Api.post("forgetpassword", value);
      if (info.data.status_code === 200) {
        toast.success(info.data.message);
        return info.data.data;
      } else {
        toast.error(info.data.message);
      }
    } catch (error) {
      console.log(error, "errorerrorerrorerror");
      toast.error(error.response.data.errors[0]);
    }
  }
);

//get-sub-admin-info
